const MENSAJE_GUIA_MIXTO =
  'No se pudo crear la guía. El empaque no se facturó. El carrito se mantiene para que puedas reintentar.';

const esItemEnvio = (item: { envioNacional?: unknown; envioNacionalColombia?: unknown }): boolean =>
  Boolean(item.envioNacional || item.envioNacionalColombia);

export function mensajeErrorFactura(
  raw: string,
  carrito: Array<{ envioNacional?: unknown; envioNacionalColombia?: unknown }>,
): string {
  const tieneEnvio = carrito.some(esItemEnvio);
  const tieneEmpaque = carrito.some(item => !esItemEnvio(item));
  if (tieneEnvio && tieneEmpaque && /gu[ií]a/i.test(raw)) {
    return MENSAJE_GUIA_MIXTO;
  }
  return raw;
}
